module.exports = __webpack_public_path__ + "static/img/tw.81bde41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/tw.png
// module id = FYxl
// module chunks = 1